import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

//production api
const firebaseConfig = {
  apiKey: "AIzaSyDNnQRWQhhqULlE_qhE1vUcL0K7PiAwU9k",
  authDomain: "zindua-ke.firebaseapp.com",
  projectId: "zindua-ke",
  storageBucket: "zindua-ke.firebasestorage.app",
  messagingSenderId: "638962875996",
  appId: "1:638962875996:web:c819efea79a3b13c127099",
  measurementId: "G-99YLJ09VHR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export {app, analytics}